import type { AppLocale } from "@/lib/utils/i18n";

const dateLocaleByAppLocale: Record<AppLocale, string> = {
  ar: "ar-MA",
  fr: "fr-FR",
  en: "en-GB",
};

export const formatWeekdayShort = (locale: AppLocale, dateValue: string) => {
  const formatter = new Intl.DateTimeFormat(dateLocaleByAppLocale[locale], {
    weekday: "short",
    timeZone: "Africa/Casablanca",
  });

  return formatter.format(new Date(dateValue));
};

export const formatShortDate = (locale: AppLocale, dateValue: string) => {
  const formatter = new Intl.DateTimeFormat(dateLocaleByAppLocale[locale], {
    day: "numeric",
    month: "short",
    timeZone: "Africa/Casablanca",
  });

  return formatter.format(new Date(dateValue));
};

export const formatLocalizedDate = (locale: AppLocale, dateValue: string) => {
  const formatter = new Intl.DateTimeFormat(dateLocaleByAppLocale[locale], {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "Africa/Casablanca",
  });

  return formatter.format(new Date(dateValue));
};

export const formatLocalizedTimeAgo = (locale: AppLocale, dateValue: string) => {
  const publishedAt = new Date(dateValue).getTime();
  const now = Date.now();
  const diffMs = Math.max(0, now - publishedAt);
  const minutes = Math.floor(diffMs / (1000 * 60));
  const formatter = new Intl.RelativeTimeFormat(dateLocaleByAppLocale[locale], {
    numeric: "auto",
  });

  if (minutes < 1) {
    return locale === "ar" ? "منذ لحظات" : formatter.format(0, "minute");
  }

  if (minutes < 60) {
    return formatter.format(-minutes, "minute");
  }

  const hours = Math.floor(minutes / 60);

  if (hours < 24) {
    return formatter.format(-hours, "hour");
  }

  const days = Math.floor(hours / 24);

  return formatter.format(-days, "day");
};

export const formatArabicDate = (dateValue: string) => formatLocalizedDate("ar", dateValue);

export const formatArabicTimeAgo = (dateValue: string) => formatLocalizedTimeAgo("ar", dateValue);
